import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type { ProductFormulation } from '@/constants/products';
import { MAX_DAILY_DOSE_FORMULATIONS } from './constants';
import { getFormulationFilter } from './getFormulationFilter';

/** Whether pad items of this formulation get the maximum daily dose input, chip and dosage-text phrase. */
export const supportsMaxDailyDose = (formulation: ProductFormulation) => MAX_DAILY_DOSE_FORMULATIONS.has(formulation);

/** Whether a pad item gets a maximum daily dose, from the formulation it was filtered by */
export const padItemSupportsMaxDailyDose = ({ filters }: Pick<MedicationPadItemType, 'filters'>) => {
  const formulation = getFormulationFilter(filters);
  return formulation !== undefined && supportsMaxDailyDose(formulation);
};
